import { environment } from '../../../environments/environment';

const defaultBrandName = 'Meetrix';
const defaultBrandLogoPath = 'meetrix-mark.svg';

export const BRANDING = Object.freeze({
  name: environment.brandName?.trim() || defaultBrandName,
  logoPath: environment.brandLogoPath?.trim() || defaultBrandLogoPath,
});

export function withBrandName(suffix: string): string {
  const trimmed = suffix.trim();
  return trimmed ? `${BRANDING.name} ${trimmed}` : BRANDING.name;
}
